import { render, staticRenderFns } from "./CuringRuleView.vue?vue&type=template&id=5cca85e0&scoped=true&"
import script from "./CuringRuleView.vue?vue&type=script&lang=js&"
export * from "./CuringRuleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cca85e0",
  null
  
)

export default component.exports